import { NullableString } from 'mapistry-shared';

export const hasForbiddenHtml = (text: NullableString | undefined): boolean => {
  if (!text) return false;
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const allEl = Array.from(doc.getElementsByTagName('*')).map(
    (e) => e.nodeName,
  );
  // all of the allowed HTML tags, which includes HTML, HEAD, and BODY because of the DOMParser
  const allowedHTMLTags = [
    'HTML',
    'HEAD',
    'BODY',
    'B',
    'STRONG',
    'H1',
    'H2',
    'A',
    'I',
    'P',
  ];
  const allTagsAreAllowed = allEl.every((elem) =>
    allowedHTMLTags.includes(elem),
  );

  return !allTagsAreAllowed;
};
